export const FailSearchUnit = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="201"
    height="200"
    fill="none"
    viewBox="0 0 201 200"
  >
    <path
      fill="#EEF4FF"
      d="M161.942 75.784S141.279 93.2 163.28 132.11c19.538 34.555-27.153 48.19-46.96 43.751-25.658-5.75-39.473-39.195-59.533-29.194-20.059 10.002-38.172-37.978-8.926-54.758 36.38-20.874 13.84-34.069 17.533-49.934 2.65-11.386 35.953-28.28 53.008-7.668 14.351 17.344 21.826 11.447 28.69 9.345 9.9-3.03 30.775 14.498 14.85 32.13"
    />
    <path
      stroke="#363BC4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M91.036 83.929h8.84m-8.84 12.857h8.84m-8.84 12.857h8.84m11.249-25.714h8.84m-8.84 12.857h8.84m-8.84 12.857h8.84m11.25 19.286V81.357c0-3.6 0-5.4-.701-6.775a6.43 6.43 0 0 0-2.809-2.81c-1.376-.7-3.176-.7-6.776-.7H90.072c-3.6 0-5.4 0-6.776.7a6.43 6.43 0 0 0-2.81 2.81c-.7 1.375-.7 3.175-.7 6.775v47.572m57.857 0H73.357"
    />
    <path
      fill="#363BC4"
      d="M146.553 58.43c-3.239-1.352-5.528-.054-6.069 1.241-.391.936.22 1.699.868 1.97 1.295.54 1.539-1.527 3.986-.505 1.2.501 1.939 1.43 1.478 2.534-.542 1.295-2.196 1.478-3.268 1.819-.947.31-2.269.912-3.131 2.975-.522 1.248-.336 1.748.648 2.16 1.175.49 1.635.063 1.826-.393.521-1.248.846-1.958 2.596-2.438.859-.233 3.58-1.013 4.522-3.268s-.385-4.811-3.456-6.094M140.397 72.289a2.002 2.002 0 0 0-1.544 3.695 2.001 2.001 0 0 0 2.616-2.607c-.2-.49-.585-.881-1.072-1.088"
    />
  </svg>
);
